import React, { Component } from 'react';
import * as R from 'ramda';
import ScrollArea from 'react-scrollbar';
import './LLMChat.css';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import { connect } from 'react-redux';

const SUGGESTED_QUESTIONS = [
  { label: '✅ Summarize strengths', value: 'Summarize the strengths of this person' },
  { label: '⚠️ What to watch out for?', value: 'Show me the bullet points of potential risks or development areas' },
  { label: '🎯 Ask in interview', value: 'Suggest interview questions to clarify gaps or explore potential.' },
  {
    label: '🧩 If hired',
    value:
      'Suggest recommendations for support, environment, or development if the candidate joins. Give hints on how to best onboard and what to focus on based on their profile.'
  },
  { label: '👋 How to onboard?', value: 'How to best onboard this person?' }
];

class LLMChatMessage extends Component {
  render() {
    const { content, contentHtml, role } = this.props;
    return (
      <div className={`LLMChatMessage ${role.toLowerCase()}`}>
        <div className="LLMChatMessageContent">
          {contentHtml ? <div dangerouslySetInnerHTML={{ __html: contentHtml }} /> : content}
        </div>
      </div>
    );
  }
}

class LLMChat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      suggestedQuestions: SUGGESTED_QUESTIONS,
      chat: props.chat || [],
      loading: false,
      id: `LLMChat-${Math.random().toString(36).substring(2, 15)}`
    };
  }

  handleChange = event => {
    this.setState({ message: event.target.value });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chat !== this.props.chat) {
      this.setState({ chat: this.props.chat });
      this.scrollToBottom();
    } else if (prevState.chat !== this.state.chat) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    setTimeout(() => {
      const messagesEnd = document.querySelector(`#${this.state.id} .LLMChatMessages > *:last-child`);
      if (messagesEnd) {
        messagesEnd.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  handleNewUserMessage = async message => {
    const { chat, loading } = this.state;
    if (loading) {
      return;
    }

    const newChat = [...chat, { role: 'USER', content: message, contentHtml: message }];
    this.setState({
      loading: true,
      chat: newChat
    });

    try {
      const resp = await fetch('/api/v1/admin/ai/chat', {
        method: 'POST',
        body: JSON.stringify({
          messages: R.map(R.omit(['hidden']))(newChat),
          ...this.props.params
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.auth.access_token}`
        }
      });

      const { payload, error, errorMessage } = await resp.json();
      const err = error || errorMessage;

      if (err) {
        throw new Error(err);
      }

      this.setState({
        chat: [...newChat, payload.message]
      });
    } catch (err) {
      console.error('err', err);
      this.setState({ error: err.message });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    event.stopPropagation();
    const { message } = this.state;
    this.setState({ message: '' });
    this.handleNewUserMessage(message);

    // setTimeout(() => {
    //   this.setState(({ chat }) => ({
    //     loading: false,
    //     chat: [
    //       ...chat,
    //       {
    //         role: 'ASSISTANT',
    //         content: 'Hello, how can I help you today?',
    //         contentHtml: 'Hello, how can I help you today?'
    //       }
    //     ]
    //   }));
    // }, 1000);
  };

  handleSuggestedQuestionClick = question => {
    const { loading } = this.state;
    if (loading) {
      return;
    }
    this.setState(({ suggestedQuestions }) => {
      return {
        suggestedQuestions: R.map(
          q => ({ ...q, disabled: q.disabled || q.value === question.value }),
          suggestedQuestions
        )
      };
    });
    this.handleNewUserMessage(question.value);
  };

  render() {
    const { enabled } = this.props;
    const { chat, message, loading, error, suggestedQuestions } = this.state;
    return (
      <form id={this.state.id} onSubmit={this.handleSubmit}>
        <div className="LLMChat">
          <div className="LLMChatMessages">
            {R.addIndex(R.map)((message, index) => <LLMChatMessage key={index} {...message} />)(
              R.filter(m => !m.hidden, chat)
            )}
            {loading && (
              <div className="LLMChatLoading">
                <CircularProgress size={24} thickness={4} />
              </div>
            )}
          </div>
          {enabled && (
            <div className="LLMChatInputContainer">
              <div className="LLMChatSuggestedQuestions">
                {R.map((question, index) => (
                  <div
                    key={index}
                    className="LLMChatSuggestedQuestion"
                    data-disabled={question.disabled}
                    onClick={() => this.handleSuggestedQuestionClick(question)}
                  >
                    {question.label}
                  </div>
                ))(suggestedQuestions)}
              </div>
              <div className="LLMChatInput">
                <TextField
                  fullWidth
                  placeholder="Or ask your own question..."
                  onChange={this.handleChange}
                  value={message}
                  style={{ fontSize: '14px' }}
                />
              </div>
            </div>
          )}
          {error && <div className="LLMChatError">{error}</div>}
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(LLMChat);



// WEBPACK FOOTER //
// ./src/components/chats/LLMChat.js